import { getAuthToken } from "../services/api";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import { setIdentifier, setTokens, setUserProfile } from "../redux/Slices/authSlice";
import { useConfig } from "../App";

export const useAuthToken = () => {
   const cfg = useConfig(); 
   const proxyString = cfg.config.services.PROXY_STRING;
   const authApiString = cfg.config.services.AUTH_API_STRING;
   const apiUrl = `${proxyString}${authApiString}`;
   const sourceHeader = cfg.config.services.API_SOURCE_HEADER;
  // check redux 
  const dispatch = useDispatch();
  const identifierId = useSelector((state) => state.auth.identifierId) 
  || localStorage.getItem("identifierId");
  // generate new if not present in redux or localstorage
   const ensureIdentifier = () => {
    if (!identifierId) {
      const newId = uuidv4();
      dispatch(setIdentifier(newId));
      localStorage.setItem("identifierId", newId);
      // console.log("Generated new identifierId:", newId);
      // console.log("Stored identifierId in localStorage:", localStorage.getItem("identifierId"));
      return newId;
    }
    return identifierId;
  };
 
  const getToken = async() => {
    const id = ensureIdentifier();
    // build payload
     const payload = {
      identifier: id,
      type: "guest",
    };
    const { tokenData } = await getAuthToken(payload,apiUrl,sourceHeader);
    // console.log("TOKEN DATA", tokenData)
    // store in redux 
     dispatch(
      setTokens({
        accessToken: tokenData.accessToken,
        refreshToken: tokenData.refreshToken,
        expiresAt: tokenData.expiresAt
      })
    );
     dispatch(
      setUserProfile({
        userProfile: tokenData.userProfile,
      })
    );
    return await tokenData;
  }
  return { getToken };
}
